import React from 'react';
// eslint-disable-next-line import/no-unresolved
import loadable from '@loadable/component';
import { AddonProductVariantProps } from './AddonProductField.types';

const FormFieldController = loadable(() => import('../../../../../components/Form/FormFieldController'), {
  resolveComponent: (components) => components.FormFieldController,
});

type AddonProductFormFieldsProps = Pick<
  AddonProductVariantProps,
  'product' | 'control' | 'errors' | 'watch' | 'setValue'
>;

export const AddonProductFormFields = ({ product, control, errors, watch, setValue }: AddonProductFormFieldsProps) => (
  <FormFieldController
    control={control}
    fieldComponents={product.fieldComponents}
    errors={errors}
    fieldNamePrefix={`${product.productNumber}.props`}
    watch={watch}
    setValue={setValue}
  />
);
